import { StateCreator, StoreMutatorIdentifier } from 'zustand';
import { logger } from '@ninja/utilities';

type Logger = <
	T = unknown,
	Mps extends [StoreMutatorIdentifier, unknown][] = [],
	Mcs extends [StoreMutatorIdentifier, unknown][] = []
>(
	f: StateCreator<T, Mps, Mcs>,
	name: string
) => StateCreator<T, Mps, Mcs>;

type LoggerImpl = <T = unknown>(f: StateCreator<T, [], []>, name?: string) => StateCreator<T, [], []>;

const loggerMiddleware: LoggerImpl = (f, name) => (set, get, store) => {
	const loggedSet: typeof set = (...a) => {
		set(...a);

		logger.log(`%c[ZuStand][State Update][${name}]: `, 'color: #4CAF50; font-weight: bold', get());
	};

	store.setState = loggedSet;

	return f(loggedSet, get, store);
};

export default loggerMiddleware as unknown as Logger;
